module.exports = __webpack_public_path__ + "static/media/Frame_7.c8de5e2a.png";